import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartPlus, faUser, faBars, faTimes, faMapMarkerAlt, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import selsmartLogo from '../../assets/images/selsmart.png';

import { useUser } from '../../contexts/userContext';
import { useCart } from '../../contexts/cartContext';
import searchbarImage from '../../assets/images/search.svg';
import { ClipLoader } from 'react-spinners'; // Import the spinner
import { Link } from 'react-router-dom';
import './common.css';
import { jwtDecode, JwtPayload } from "jwt-decode";
import { useRefresh } from '../../contexts/refreshLogin';

interface CityPopupProps {
    onClose: () => void;
    onFetchLocation: () => void;
    onCitySelected: (cityName: string) => void; // Callback to update city in Header
    setIsLoading: (loading: boolean) => void;
}

interface Product {
    // product_id: Key | null | undefined;
    title: string;
    cat_id: number;
}

interface Category {
    cat_id: number;
    title: string;
    parent_cat_id: number | null;
    slug: string;
    parent_title: string;
    children: Category[];
}

const Sidebar: React.FC<{
    categories: Category[];
    onSelectCategory: (cat_id: number) => void;
    onIsCategoriesVisible: (cateVis: boolean) => void;
    isCategoriesVisible: boolean;
}> = ({
    categories,
    onSelectCategory,
    onIsCategoriesVisible,
    isCategoriesVisible,
}) => {
        const renderCategories = (categories: Category[], level = 0) => {
            // Only allow rendering up to the second level
            if (level > 1) return null;

            return (
                <ul className={`category-level-${level} mobile-view-left-panel`}>
                    {categories.map((category) => (
                        <li key={category.cat_id}>
                            <a
                                onClick={() => {
                                    onSelectCategory(category.cat_id);
                                    onIsCategoriesVisible(!isCategoriesVisible)
                                }}
                                className="category-title"
                                style={{ cursor: "pointer", paddingLeft: `${level * 10}px` }}
                            >
                                {category.title}
                            </a>
                            {/* Render only up to one level of children */}
                            {level === 0 &&
                                category.children &&
                                category.children.length > 0 &&
                                renderCategories(category.children, level + 1)}
                        </li>
                    ))}
                </ul>
            );
        };

        return <div className="sidebar">{renderCategories(categories)}</div>;
    };

const Header: React.FC = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userName, setUserName] = useState('');
    const [cities, setCities] = useState<{ name: string }[]>([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCity, setSelectedCity] = useState<string | null>(null);
    const [city, setCity] = useState<string>('Select City');
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [session_code, setSessCode] = useState<string | null>(null);
    const [categories, setCategories] = useState([]);
    const [showSuggestionss, setShowSuggestionss] = useState(false);
    const { cartQuantity, setCartQuantity } = useCart();
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState<any[]>([]);
    const [searchData, setsearchData] = useState<any[]>([]);
    const { user_id, user_name, city_name ,fetchCsrfToken} = useUser();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const { refreshKey, setRefreshKey } = useRefresh();
    const [highlightedIndex, setHighlightedIndex] = useState(-1); // Track highlighted suggestion
    const suggestionsRef = useRef<HTMLUListElement>(null);
    const [loginShowKey, setloginShowKey] = useState<string | null>(null);
    
    const location = useLocation();
    const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, sess_code, setUserId, setUsername, setUtmSessionId,globalUtmQueryRef } = useUser();
    const navigate = useNavigate();
    const { fetchCartQuantity } = useCart();
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    const google_api_key = process.env.GOOGLE_API_KEY
    const utmQuery = localStorage.getItem("utm_query_data") || "";

    const handleCart = () => {

        if (cartQuantity === 0 || cartQuantity === null || isNaN(cartQuantity)) {
            // Show popup if cart is empty
            setShowModal(true);
        }
        else {
            // Navigate to the cart page if items are in the cart
            navigate('/cart/listing');
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        navigate('/sell-used-appliances')
        window.scrollTo({ top: 0, behavior: 'smooth' })
    };

    const handleLoginShow = () => {
        
      if(isLoggedIn == false){
        setloginShowKey('Login')
      }
    };
    useEffect(() => {
        handleLoginShow()
        const loginState = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(loginState);
        const storedUserName = localStorage.getItem('userName') || 'User';
        setUserName(storedUserName);
    }, [refreshKey]);

    useEffect(() => {
        
        handleLoginShow()
        const loginState = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(loginState);
        const storedUserName = localStorage.getItem('userName') || 'User';
        setUserName(storedUserName);
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${backendUrl}api/v2/product-category`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        
                        credentials: "include",
                        mode:"cors"
        
                      }
                );
                const data = await response.json();
                setCategories(data.data);
            } catch (error) {
                //console.error('Error fetching categories:', error);
            }
        };

        fetchCategories();
    }, []);

    const handleNavClickd = (path: string) => {
        window.location.href = path; // Adjust this based on your navigation handling
    };

    useEffect(() => {
       

        const fetchCities = async () => {
            try {
                const response = await fetch(`${backendUrl}api/v2/all-city`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        
                        credentials: "include",
                        mode:"cors"
        
                      }
                );
                const data = await response.json();
                if (data.data && Array.isArray(data.data[0])) {
                    setCities(data.data[0]);
                }
                const login = localStorage.getItem("isLoggedIn")
                if (login === 'true') {
                    fetchCartQuantity(sess_code || 'defaultSessionCode')
                }
            } catch (error) {
                //console.error('Error fetching cities:', error);
            }
        };
        fetchCities();
    }, []);

    const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);
    //const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev); // Toggle dropdown state
      };
    const handleNavClick = (path: string) => {
        if (location.pathname !== path) {
            navigate(path); // Navigate to the new path
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    };
    const handleLoginClick = () => {
        sessionStorage.removeItem("requestData");
        sessionStorage.removeItem("categoryType");
        sessionStorage.removeItem('categoryId');
        sessionStorage.removeItem('productId');
        navigate('/login',{state:{utmQuery:globalUtmQueryRef.current}})
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
        ;
    const handleLogoutClick = () => {
        sessionStorage.clear()
        localStorage.clear()
        // localStorage.removeItem('isLoggedIn');
        // localStorage.removeItem('user_id');
        // localStorage.removeItem('userName');
        // localStorage.removeItem('auth_token');
        // localStorage.removeItem('city_name');
        // localStorage.removeItem('cartQuantity');
        // sessionStorage.removeItem('session_code');
        // localStorage.removeItem("GlobalSearchTerm");
        // sessionStorage.removeItem("requestData");
        // sessionStorage.removeItem("categoryType");
        // sessionStorage.removeItem('categoryId');
        // sessionStorage.removeItem('productId');
        setUserId(null)
        setUsername(null)
        setcityName(null)
        setUtmSessionId(null)
        setCartQuantity(0);
        setSessCode(null);
        setSessionCode("")
        setIsLoggedIn(false);
        setIsDropdownOpen(false);
        setSelectedCity(null);
        navigate('/');
        window.scrollTo({ top: 0, behavior: 'smooth' })
        window.location.reload();
        localStorage.clear()
        sessionStorage.clear()
    };

    const handleFaqs = () => {
        setGlobalSearchTerm("");
        navigate('/faq')
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }


    const handleaboutUS = () => {
        setGlobalSearchTerm("");
        navigate('/about-us')
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleUsedAppliances = () => {
        navigate('/sell-used-appliances')
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleHome = () => {
        setGlobalSearchTerm("")
        navigate('/')
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.location.reload()
    }

    const handleSellNow = () => {
        if (!city_name) {
            navigate('/')
            alert('Please choose your location.')
            setIsPopupVisible(true)
        } else {
            if (location.pathname === '/sell-used-appliances') {
                window.location.reload();
            } else {
                navigate('/sell-used-appliances');
            }
        }

    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!showSuggestions || suggestions.length === 0) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setHighlightedIndex((prevIndex) =>
                prevIndex < suggestions.length - 1 ? prevIndex + 1 : 0
            );
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setHighlightedIndex((prevIndex) =>
                prevIndex > 0 ? prevIndex - 1 : suggestions.length - 1
            );
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (highlightedIndex >= 0 && highlightedIndex < suggestions.length) {
                handleSuggestionClick(suggestions[highlightedIndex]);
            }
        }
    };
    const fetchSuggestions = async (inputValue: string) => {
        if (inputValue.trim()) {
            try {
                const response = await fetch(
                    `${backendUrl}api/v2/product/search?title=${encodeURIComponent(inputValue)}`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        credentials: "include",
                mode:"cors"
 
                  
                      }
                );
                const data = await response.json();
                // //console.log("API Response:", data); // Log the full response for debugging

                const products = data.data?.data; // Get products from response
                if (Array.isArray(products) && products.length > 0) {
                    setSuggestions(products); // Set suggestions to display to the user
                } else {
                    setSuggestions([]); // No suggestions found
                }
                setShowSuggestions(true); // Always show suggestions box
            } catch (error) {
                //console.error("Error fetching suggestions:", error);
                setSuggestions([]); // Clear suggestions on error
                setShowSuggestions(true); // Show "No data found" in case of an error
            }
        } else {
            setSuggestions([]); // Clear suggestions when input is empty
            setShowSuggestions(false); // Hide suggestions when input is empty
        }
    };


    const handleSearch = async () => {

        if (searchTerm.trim()) {
            localStorage.setItem("GlobalSearchTerm", searchTerm.trim());
            try {
                const response = await fetch(
                    `${backendUrl}api/v2/product/search?title=${encodeURIComponent(searchTerm)}`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        credentials: "include",
                        mode:"cors"        
                  
                      }
                );
                const data = await response.json();
                const products = data.data.data;

                if (Array.isArray(products) && products.length > 0) {
                    const firstProduct = products[0];
                    const catId = firstProduct.cat_id;
                    if (window.location.pathname === '/sell-used-appliances') {
                        if(user_id){
                            const search ='search'
                            const csrfToken = await fetchCsrfToken();
                              const response = await fetch(
                                `${backendUrl}api/v2/user-log/${user_id}/${sess_code}?checkout=${search}`,
                                {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    'X-CSRF-Token': csrfToken,
                                  },
                                  credentials: "include",
                                  body: JSON.stringify({
                                    searchProduct:searchTerm,
                                    
                                  }),
                                }
                              );
                        }
                     
                        setsearchData(data.data.data)
                        window.location.href = `/sell-used-appliances?product=${encodeURIComponent(searchTerm)}`; // Force refresh
                    } else {
                        if(user_id){
                            const search ='search'
                            const csrfToken = await fetchCsrfToken();
                              const response = await fetch(
                                `${backendUrl}api/v2/user-log/${user_id}/${sess_code}?checkout=${search}`,
                                {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    'X-CSRF-Token': csrfToken,
                                  },
                                  credentials: "include",
                                  body: JSON.stringify({
                                    searchProduct:searchTerm,
                                    
                                  }),
                                }
                              );
                        }
                       
                        navigate(`/sell-used-appliances?product=${encodeURIComponent(searchTerm)}`, { state: { searchData: searchData } }); // Navigate without reload
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }

                } else {
                    // //console.log('No products found');
                }
            } catch (error) {
                //console.error('Error fetching search results:', error);
            }
        }
    };

    const handleSuggestionClick = (product: any) => {
        // //console.log("suggestion-search---")
        setSearchTerm(product.title); // Set the search term to the clicked suggestion
        setGlobalSearchTerm(product.title)
        setShowSuggestions(false); // Hide suggestions after selection
        localStorage.setItem("GlobalSearchTerm", product.title);


        if (window.location.pathname === '/sell-used-appliances') {
            window.location.href = `/sell-used-appliances?product=${product.title}`; // Force refresh
            // navigate(`/sell-used-appliances?cat_id=${product.cat_id}`);
        } else {
            navigate(`/sell-used-appliances?product=${product.title}`); // Navigate without reload
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }

        // Navigate to the appropriate page
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (suggestionsRef.current && !suggestionsRef.current.contains(event.target as Node)) {
                setShowSuggestions(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('click', handleClickOutside);
        };

    }, []);
    const handleBlur = () => {
        setTimeout(() => setShowSuggestions(false), 100); // Delay hiding the dropdown to allow click
    }

    // const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => setSelectedCity(e.target.value);

    const handleProfileClick = () => {
        setGlobalSearchTerm("")
        setIsDropdownOpen(false);
        navigate('/profile', { state: { user_id: user_id } });
        window.scrollTo({ top: 0, behavior: 'smooth' })
    };

    const handleSelectCityClick = () => setIsPopupVisible(true);
    const handleClosePopup = () => {
        setIsPopupVisible(false);
        if (isLoading) {
            setIsLoading(false); // Ensure loader is hidden if popup is closed
        }
    }

    const onFetchLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    // //console.log('Latitude:', latitude);
                    // //console.log('Longitude:', longitude);
                    fetchCityDetails(latitude, longitude);
                    setIsPopupVisible(false);
                },
                (error) => {
                    //console.error('Error fetching location:', error);
                    alert('Unable to fetch location. Please check your location settings.');
                }
            );
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    };

    const fetchCityDetails = async (latitude: number, longitude: number) => {
        const apiKey = 'AIzaSyCO66yKQ63AX-lQmhU7bRUiRkbpGP9nGeU'; // Replace with your Google API Key

        try {
            // //console.log('Fetching city details for coordinates:', google_api_key);

            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
            );

            if (!response.ok) {
                throw new Error('Failed to fetch city details');
            }

            const data = await response.json();

            if (data.status !== 'OK') {
                throw new Error('No results found');
            }

            // Extract city and state from the response
            const addressComponents = data.results[0].address_components;
            const city = addressComponents.find((component: any) => component.types.includes('locality') || component.types.includes('administrative_area_level_1'))?.long_name || 'Unknown city';
            const state = addressComponents.find((component: any) => component.types.includes('administrative_area_level_1'))?.long_name || 'Unknown state';
            const pincode = addressComponents.find((component: any) =>
                component.types.includes('postal_code')
            )?.long_name || 'Unknown pincode';
           
            const locality = addressComponents.find((component: any) =>
                component.types.includes('sublocality') || component.types.includes('neighborhood') || component.types.includes('locality')
            )?.long_name || 'Unknown locality';
            const pincodeResponse = await fetch(`${backendUrl}api/v2/pincode/${pincode}`,{  method: 'GET',
                headers:{
                  // Accept:'aplication/json',
                  "Content-Type": "application/json",
                },
                credentials: "include",
                mode:"cors"                          
              });
            const ipResponse = await fetch("https://api.ipify.org?format=json");
            
            if (!ipResponse.ok) {
                throw new Error("Failed to fetch IP address");
            }
            
            const ipData = await ipResponse.json();
            const ip_address = ipData.ip; // Extract IP

            if (pincodeResponse.ok) {
                
                const pincodeData = await pincodeResponse.json();
                const userId =user_id
                const csrfToken = await fetchCsrfToken();
                const saveInfo = await fetch(`${backendUrl}api/v2/location-save?${utmQuery}`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      'X-CSRF-Token': csrfToken,
                    },
                    credentials: "include",
                    body:JSON.stringify({pincode:pincode,city:pincodeData.data.city,locality:locality,user_id:userId,user_agent:navigator.userAgent,ip_address:ip_address}) ,
                    
                  });
                if (pincodeData?.data?.city) {
                    const cityName = pincodeData.data.city;
                    const stateName = pincodeData.data.state;

                    // Set city and state
                    setcityName(cityName);
                    sessionStorage.setItem('cityName', cityName);
                    sessionStorage.setItem('stateName', stateName);

                    // Close the popup after successful city detection
                    setIsPopupVisible(false);
                } else {
                    alert('City data not available for the detected pincode.');
                }
            } else {
                alert('Failed to fetch city data by pincode.');
            }
        } catch (error) {
            alert('Failed to fetch location. Please try again.');
        } finally {
            setIsLoading(false); // Stop loading spinner
        }
    };

    const getCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    fetchCityDetails(latitude, longitude); // Call the function with coordinates
                },
                (error) => {
                    //console.error('Error getting location:', error);
                }
            );
        } else {
            //console.error('Geolocation is not supported by this browser.');
        }
    };

    // useEffect(() => {
    //     getCurrentLocation(); 
    // }, []);

    const handleCitySelected = (cityName: string) => {
        setSelectedCity(cityName);
        setIsLoading(false);
    };

    const handleListShowCat = () => {
        if(showSuggestionss == true){
            setShowSuggestionss(false)
        }else{
            setShowSuggestionss(true)
        }
        
    };

    // setShowSuggestionss(true)

    // const getTokenExpirationTime = (token: string): number | null => {
    //   try {
    //     const decodedToken = jwtDecode<JwtPayload & { exp?: number }>(token);


    //     if (decodedToken.exp) {
    //       return decodedToken.exp * 1000; 
    //     }
    //     return null;
    //   } catch (error) {
    //     //console.error("Invalid token:", error);
    //     return null;
    //   }
    // };

    // useEffect(() => {
    //     let auth_token = localStorage.getItem("auth_token") as string;
    //     let auth_token_exp = getTokenExpirationTime(auth_token);
    //     //console.log("auth_token_exp timestamp", auth_token_exp,new Date().getTime());
    //     if (auth_token_exp && auth_token_exp <= new Date().getTime()) {
    //       //console.log("session token expired functionality triggered");
    //       handleLogoutClick();
    //     } else {
    //       //console.log("session token expired functionality not triggered");
    //     }

    // },[])

    const CityPopup: React.FC<CityPopupProps> = ({ onClose, onFetchLocation, onCitySelected }) => {
        const [searchTerm, setSearchTerm] = useState<string>('');
        const [error, setError] = useState<string | null>(null);
        const [isLoading, setIsLoading] = useState<boolean>(false);
        const backendUrl = process.env.REACT_APP_BACKEND_URL; // Update with your backend URL
        const pincodeInputRef = useRef<HTMLInputElement>(null);

        const handlePincodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            // Allow only numeric input and limit length to 6 digits
            if (/^\d{0,6}$/.test(value)) {
                setSearchTerm(value);
                setError(null); // Clear error when input changes
                if (value.length < 6) {
                    setError('6 digits required');
                } else {
                    setError(null);
                }
                // If pincode is 6 digits, automatically fetch city
                if (value.length === 6) {
                    onSelectCity(value); // Trigger city selection when the 6th digit is entered
                }
            }
        };

        const onSelectCity = async (value: string) => {
            setIsLoading(true);
            setError(null); // Clear any previous errors

            try {
                const response = await fetch(`${backendUrl}api/v2/pincode/${value}`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        
                        credentials: "include",
                        mode:"cors"
        
                      }
                );
                if (response.ok) {
                    const data = await response.json();
                    // Check if city data is available
                    if (data && data.data && data.data.city) {
                        const cityName = data.data.city;
                        const stateName = data.data.state; // Assuming state is returned

                        setCity(cityName);
                        onCitySelected(cityName); // Update city in the main component
                        setSelectedCity(cityName);
                        setcityName(cityName);
                        const userId = user_id
                        const ipResponse = await fetch("https://api.ipify.org?format=json");
                        const ipData = await ipResponse.json();
                        const ip_address = ipData.ip;
                        const csrfToken = await fetchCsrfToken();
                        const saveInfo = await fetch(`${backendUrl}api/v2/location-save?${utmQuery}`, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              'X-CSRF-Token': csrfToken,
                            },
                            credentials: "include",
                            body:JSON.stringify({pincode:value,city:data.data.city,locality:null,user_id:userId,user_agent:navigator.userAgent,ip_address:ip_address}) ,
                          });
                        // cityNameSelected=cityName
                        sessionStorage.setItem('cityName', cityName);
                        sessionStorage.setItem('stateName', stateName); // Store state if needed
                        setIsPopupVisible(false); // Close popup after successful selection
                    } else {
                        // If no city found in the response
                        setError('Pincode is Invalid. Please try again.');
                    }
                } else {
                    // If response is not ok (status code not in 2xx range)
                    setError('Pincode is Invalid. Please try again.');
                }
            } catch (error) {
                //console.error('Error fetching city:', error);
                setError('Error fetching city. Please try again.');
            } finally {
                setIsLoading(false);
            }
        };

        useEffect(() => {
            // Auto-focus the pincode input field when the component mounts
            if (pincodeInputRef.current) {
                pincodeInputRef.current.focus();
            }
        }, []);

        return (
            <div className="popup-overlay">

                <div className="popup-content-city">
                    <button className="icon-close-button" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <h1>Select Your City</h1>
                    <button onClick={onFetchLocation} className="location-button" disabled={isLoading}>
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        <p className="detect-location">Detect My Location</p>
                    </button>
                    <p className="permission-location-heading">
                        We will need permission to use your device location.
                    </p>
                    <div className="or-line">
                        <hr className="line" />
                        <p className="or-title">or</p>
                        <hr className="line" />
                    </div>
                    <h3>Search Manually</h3>
                    <input
                        type="text"
                        placeholder="Pincode"
                        name="pincode"
                        value={searchTerm}
                        onChange={handlePincodeChange}
                        maxLength={6} // Restrict input length to 6 characters
                        ref={pincodeInputRef}
                        disabled={isLoading} // Disable input while fetching data
                    />
                    {error && <p className="error-message-location">{error}</p>} {/* Display error message if any */}
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (showModal) {
          disableBodyScroll(); // Disable body scrolling when modal opens
        } else {
          enableBodyScroll(); // Enable body scrolling when modal closes
        }
    
        // Cleanup to re-enable scrolling if component unmounts
        return () => enableBodyScroll();
      }, [showModal]);


    const modalStyles: { overlay: React.CSSProperties; modal: React.CSSProperties } = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
        },
        modal: {
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            textAlign: 'center',
        },
    };

    const disableBodyScroll = () => {
        document.body.style.overflow = 'hidden'; // Disable scrolling on body when modal is open
      };
      
      // Function to enable scrolling on the body
      const enableBodyScroll = () => {
        document.body.style.overflow = 'auto'; // Enable scrolling on body when modal is closed
      };

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    const cityName = sessionStorage.getItem('cityName');
    return (
        <div>
            <header>
                <nav className="navbar navbar-expand-xl bg-white">
                    <div className="container">

                        <a className="navbar-brand" href="/"> <img src={selsmartLogo} alt="Selsmart Logo" /></a>

                        <div className="location">
                            <div className='select-location' onClick={handleSelectCityClick} >
                                <FontAwesomeIcon icon={faMapMarkerAlt} className='icon-loc' />
                                <p className="location-btn">
                                    {city_name || 'Select City'}
                                </p>
                            </div>

                            {isPopupVisible && (
                                <CityPopup
                                    onClose={handleClosePopup}
                                    onFetchLocation={onFetchLocation}
                                    onCitySelected={handleCitySelected}
                                    setIsLoading={setIsLoading} // Pass setIsLoading function to CityPopup
                                />
                            )}
                            {isLoading && (
                                <div className="loader">Loading...</div> // Your loader component or styling here
                            )}
                        </div>

                        <div className="search for_mob">
                            <div className="search-input-container">
                                <input
                                    type="text"
                                    placeholder="Sell 'Products'"
                                    value={globalSearchTerm}
                                    onChange={(e) => {
                                        const value = e.target.value.trimStart(); // Allow spaces between words but no leading spaces
                                        setSearchTerm(value);
                                        setGlobalSearchTerm(value)

                                        if (value !== '') {
                                            fetchSuggestions(value);
                                        } else {
                                            setSuggestions([]); // Clear suggestions when the input is empty
                                            setShowSuggestions(false); // Hide suggestions list
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            if (searchTerm.trim() !== '' && suggestions.length > 0) {
                                                // handleSearch();
                                            }
                                        }
                                    }}
                                />
                                <button
                                    className="search-btn"
                                    // onClick={handleSearch}
                                    disabled={searchTerm.trim() === '' || suggestions.length === 0} // Disable if no input or no suggestions
                                >
                                    <img className="icon-search" src={searchbarImage} alt="Search" />
                                </button>
                            </div>

                            {/* Display suggestions or "No data found" */}
                            {showSuggestions && (
                                <ul className="suggestions-list" ref={suggestionsRef}>
                                    {suggestions.length > 0 ? (
                                        suggestions.map((product) => (
                                            <li
                                                key={product.product_id}
                                                // onClick={() => handleSuggestionClick(product)}
                                                onTouchStart={() => handleSuggestionClick(product)}
                                            >
                                                {product.title}
                                            </li>
                                            
                                        ))
                                        
 
                                    ) : (
                                        <li>No data found</li> // Display message when no suggestions exist
                                    )}
                                    
                                </ul>
                            )}

                        </div>

                        <div className="cart for_mob">
                            <FontAwesomeIcon icon={faCartPlus} onClick={handleCart} />
                            {cartQuantity != null && cartQuantity > 0 && (
                                <span className="cart-quantity">{cartQuantity}</span>
                            )}

                            {/* Popup Modal */}
                            {showModal && (
                                <div className='popup_cart' style={modalStyles.overlay}>
                                    <div style={modalStyles.modal}>
                                        <FontAwesomeIcon className="cart-empty" icon={faShoppingCart} />
                                        <p className="cart-empty-msg">Your cart is empty. Please add items first.</p>
                                        <button className="cart-empty-button" onClick={handleCloseModal}>Sell Now</button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <button
                            className="navbar-toggler"
                            type="button"
                            onClick={toggleNavbar}
                            aria-controls="navbarSupportedContent"
                            aria-expanded={isOpen}
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>


                        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarSupportedContent">
                            <div className="search for_web">
                                <div className="search-input-container">
                                    <input
                                        type="text"
                                        placeholder="Sell 'Products'"
                                        value={globalSearchTerm}
                                        onChange={(e) => {
                                            const value = e.target.value.trimStart(); // Allow spaces between words but no leading spaces
                                            setSearchTerm(value);
                                            setGlobalSearchTerm(value)

                                            if (value !== '') {
                                                fetchSuggestions(value);
                                            } else {
                                                setSuggestions([]); // Clear suggestions when the input is empty
                                                setShowSuggestions(false); // Hide suggestions list
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                    <button
                                        className="search-btn"
                                        onClick={handleSearch}
                                        disabled={searchTerm.trim() === '' || suggestions.length === 0} // Disable if no input or no suggestions
                                    >
                                        <img className="icon-search" src={searchbarImage} alt="Search" />
                                    </button>
                                </div>

                                {/* Display suggestions or "No data found" */}
                                {showSuggestions && (
                                    <ul className="suggestions-list" ref={suggestionsRef}>
                                        {suggestions.length > 0 ? (
                                            suggestions.map((product) => (
                                                <li
                                                    key={product.product_id}
                                                    onClick={() => handleSuggestionClick(product)}
                                                >
                                                    {product.title}
                                                </li>
                                            ))
                                        ) : (
                                            <li>No data found</li> // Display message when no suggestions exist
                                        )}
                                    </ul>
                                )}

                            </div>

                            <ul className="navbar-nav ms-auto mb-2- mb-lg-0">
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${location.pathname === '/' ? 'bold' : ''}`}
href='/'
                                        // onClick={() => handleNavClick('/')}
                                    >
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="nav-item drop_down_list"
                                    onMouseEnter={() => setShowSuggestionss(true)}
                                    onMouseLeave={() => setShowSuggestionss(false)}
                                    style={{ position: 'relative' }}
                                >
                                    <div className='sellnow_li'>
                                    <i className="fa-solid fa-chevron-left" onClick={handleListShowCat}></i>
                                    <a
                                        className="nav-link"
                                        style={{
                                           
                                            cursor: 'pointer',
                                            // fontWeight: location.pathname === '/sell-used-appliances' ? 'bold' : 'normal',
                                        }}
                                        onClick={() => handleUsedAppliances()}
                                    >
                                        Sell Now 
                                    </a>
                                   
                                    </div>

                                    {showSuggestionss && (
                                        <ul className="suggestion-list-sell">
                                            {categories.map((category: any) => (
                                                <li key={category.cat_id} className="suggestion-item-sell">
                                                    <a href={`/${category.slug}`} className="suggestion-link-sell">
                                                        {category.title}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>



                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${location.pathname === '/faq' ? 'bold' : ''}`}
                                        href="/faq"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                            e.preventDefault(); // Prevent default link behavior
                                            window.open('/faq', '_blank'); // Open in a new tab
                                        }}
                                    >
                                        FAQs
                                    </a>
                                </li>

                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${location.pathname === '/about-us' ? 'bold' : ''}`}
                                        href="/about-us"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                            e.preventDefault(); // Prevent default link behavior
                                            window.open('/about-us', '_blank'); // Open in a new tab
                                        }}
                                    >
                                        About Us
                                    </a>
                                </li>
                                <li className="nav-item login_botn" key={refreshKey}>
                                    <div className="sign-in" key={refreshKey}>
                                        {isLoggedIn ? (
                                            <div ref={dropdownRef}>
                                                <div className="user-name-container" onClick={toggleDropdown}>
                                                    <span className="user-names">
                                                        {user_name ? user_name.charAt(0).toUpperCase() : ''}
                                                    </span>
                                                    {isDropdownOpen && (
                                                        <div className="dropdown-menu">
                                                            <div className="dropdown-item" onClick={handleProfileClick}>
                                                                Profile
                                                            </div>
                                                            <div className="dropdown-item" onClick={handleLogoutClick}>
                                                                Sign Out
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <button className="sign-in-btn btn btn-success login_btn" onClick={handleLoginClick}>
                                                {/* <FontAwesomeIcon icon={faUser} /> */}
                                                {loginShowKey}
                                            </button>
                                        )}
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <div className="cart for_web">

                                        <FontAwesomeIcon icon={faCartPlus} onClick={handleCart} />
                                        {cartQuantity != null && cartQuantity > 0 && (
                                            <span className="cart-quantity">{cartQuantity}</span>
                                        )}

                                        {/* Popup Modal */}
                                        {showModal && (
                                            <div style={modalStyles.overlay}>
                                                <div style={modalStyles.modal}>
                                                    <FontAwesomeIcon className="cart-empty" icon={faShoppingCart} />
                                                    <p className="cart-empty-msg">Your cart is empty. Please add items first.</p>
                                                    <button className="cart-empty-button" onClick={handleCloseModal}>Sell Now</button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </li>
                            </ul>

                        </div>
                        {/* <button className="hamburger-menu" onClick={toggleMobileMenu}>
                                        <FontAwesomeIcon icon={faBars} />
                                    </button> */}
                        {/* </div> */}
                        {/* </div> */}
                    </div>
                    {/* Mobile Menu */}
                </nav>
            </header>
        </div>
    );

};

export default Header;
